module.exports = __webpack_public_path__ + "static/media/BG.0314560b.webp";